/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import axios from "axios";
import { setupCache } from "axios-cache-adapter";
import React, { useEffect, useState } from "react";
import { emeaIcon, americasIcon, asiaIcon } from "../../assets/icons";
import "./styles.scss";

interface RegionCardProps {
  region: string;
  shouldSetTeamCount: boolean;
  onClick?: () => void;
  isActive?: boolean;
}

export const setRegionColor = (type: string): string => {
  switch (type) {
    case "North America":
      return "#D658BB";
    case "Latin America":
      return "#40CC7F";
    case "Europe":
      return "#09C6C6";
    case "Asia":
      return "#ED5757";
    case "Africa":
      return "#F59B55";
    default:
      return "";
  }
};
export const setRegionIcon = (type: string): string => {
  switch (type) {
    case "North America":
    case "Latin America":
      return americasIcon;
    case "Europe":
    case "Africa":
      return emeaIcon;
    case "Asia":
      return asiaIcon;
    default:
      return "";
  }
};

export const RegionCard = (props: RegionCardProps): JSX.Element => {
  const { region, shouldSetTeamCount, onClick, isActive } = props;
  const [teamCount, setTeamCount] = useState(0);

  const cache = setupCache({
    maxAge: 15 * 60 * 1000,
  });
  const api = axios.create({
    adapter: cache.adapter,
  });

  useEffect(() => {
    if (shouldSetTeamCount) {
      api
        .get(
          `https://api.igem.io/api/openingWeekend/numberOfTeams?Region=${region}`
        )
        .then((value) =>
          setTeamCount(value.data.data.totalNumberOfFilteredTeams)
        )
        .catch(() => setTeamCount(0));
    }
  }, []);
  return (
    <div className="rc">
      <button type="button" onClick={onClick}>
        {shouldSetTeamCount && <p className="rc-count">{teamCount}</p>}
        <img
          src={setRegionIcon(region)}
          alt={`region-${region}`}
          style={{ backgroundColor: setRegionColor(region) }}
        />
        <p style={{ color: isActive ? setRegionColor(region) : "" }}>
          {region}
        </p>
      </button>
    </div>
  );
};

RegionCard.defaultProps = {
  onClick: () => {},
  isActive: false,
};
